import { useContext, } from 'react';

import TenantContext from '../contexts/tenant';

export default function useTenant () {
  const tenant = useContext(TenantContext);

  return { tenant };
};
